import http from '@/utils/http'

const orderApi = {

  // 获取订单列表接口
  getOrderList(data: any) {
    return http.post<any>('/business/order/findPageList', data)
  },

  // 订单详情
  getOrderDetails(data: any) {
    return http.post<any>('/business/order/findById', data)
  },

  // 取消订单
  cancelOrder(data: any) {
    return http.post<any>('/business/order/cancelById', data)
  },

  // 删除订单
  delOreder(data: any) {
    return http.post<any>('/business/order/deleteById', data)
  },

  // 通过订单编号获取门店数量
  getStoreNum(data: any) {
    return http.get<any>('/business/order/portal/findFeedback',{data})
  },

  // 通过门店获取门店的素材
  getStoreMaterial(data: any) {
    return http.get<any>('/business/order/portal/findFeedbackPortalDetailMaterial',{data})
  }


}

export default orderApi
